import React, { useState, memo, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import "./Registration.css";
import { useFormik } from "formik";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
// import { registration } from "../../store/models/auth/auth.thunk";
import {
  loginWithGoogle,
  // loginWithYandex,
  registration,
  verifyAuthUser,
} from "../../store/models/auth/auth.thunk";
import { useAppDispatch, useAppSelector } from "../../store/hooks/store.hooks";
import * as Yup from "yup";
import {
  alpha,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  DialogContentText,
  styled,
  Switch,
  Typography,
  CircularProgress,
} from "@mui/material";
import {
  setAuthorizationModal,
  setRedirect,
  setRegistrationModal,
} from "../../store/models/auth/auth.slice";
import { useNavigate } from "react-router-dom";
import { RegistrationSelector } from "./Registration.selector";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import googlePng from "../../assets/google.png";
import steamPng from "../../assets/steam.png";
import yandexPng from "../../assets/yandex.png";
import { ReCaptchaComponent } from "../ReCaptcha";

const RedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "rgba(223, 0, 67, 1)",
    "&:hover": {
      backgroundColor: alpha(
        "rgba(19, 26, 47, 1)",
        theme.palette.action.hoverOpacity
      ),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "rgba(19, 26, 47, 1)",
  },
}));

const Registration: React.FC = memo(() => {
  const { t, i18n } = useTranslation();

  const SignupSchema = Yup.object().shape({
    registrationPassword: Yup.string()
      .min(6, i18n.t("validationschema.min"))
      .required(i18n.t("validationschema.minRequired"))
      .matches(/^(?=.*[a-z])/g, i18n.t("validationschema.matches1lowerCase"))
      .matches(/^(?=.*[A-Z])/g, i18n.t("validationschema.matches1upperCase"))
      .matches(/^(?=.*[0-9])/g, i18n.t("validationschema.matches1number")),
    registrationEmail: Yup.string()
      .matches(/^(?=.*[A-Za-z])/g, i18n.t("validationschema.onlyEn"))
      .email(i18n.t("validationschema.email"))
      .required(i18n.t("validationschema.emailRequired"))
      .matches(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        i18n.t("validationschema.email")
      ),
    registrationSwitch: Yup.bool().oneOf(
      [true],
      i18n.t("validationschema.confirmation")
    ),
    token: Yup.string().required(i18n.t("validationschema.check")),
  });

  const [openPromocode, setOpenPromocode] = useState(true);
  const [promocode, setPromocode] = useState("");
  const [infoMessage, setInfoMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rulesModal, setRulesModal] = useState(false);
  const navigate = useNavigate();
  const { open, redirect } = useAppSelector(RegistrationSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const initPromocode = sessionStorage.getItem("enprsl");
    const initLinkPromocode = localStorage.getItem("regkey");
    const isValidBase64 = (str: string | null) => {
      if (!str || typeof str !== "string") return false;
      const base64Regex = /^[A-Za-z0-9+/=]+$/;
      return base64Regex.test(str) && str.length % 4 === 0;
    };
    if (initLinkPromocode && isValidBase64(initPromocode)) {
      const linkPromo = atob(initLinkPromocode);
      const jsonData = JSON.parse(linkPromo);

      if (jsonData.promo) {
        setOpenPromocode(true);
        setValues({ ...values, registrationPromocode: jsonData.promo });
      }
    }

    if (initPromocode) {
      setOpenPromocode(true);
      setValues({ ...values, registrationPromocode: initPromocode });
    }
  }, [open]);

  const changeModal = () => {
    dispatch(setAuthorizationModal(true));
    dispatch(setRegistrationModal(false));
  };

  const handleSteamLogin = () => {
    const partner = localStorage.getItem("regkey");

    const intervalId = setInterval(() => {
      const gameToken = localStorage.getItem("game-token");

      if (gameToken) {
        dispatch(verifyAuthUser());
        dispatch(setRegistrationModal(false));
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      }
    }, 1000);

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 120000);

    const popupWindow = window.open(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/login/steam?promocod=${promocode}&partner=${partner}`,
      "_blank",
      "width=800, height=600"
    );
    //@ts-ignore
    if (window.focus) popupWindow.focus();
  };

  const handleClose = () => {
    dispatch(setRegistrationModal(false));
    dispatch(setRedirect(""));
  };

  const HandleSubmit = async (
    data: any,
    { setSubmitting, setFieldError, setStatus }: any
  ) => {
    const {
      registrationEmail,
      registrationPassword,
      registrationCurrency,
      registrationPromocode,
      token,
    } = data;

    setLoading(true);
    const response: any = await dispatch(
      registration({
        email: registrationEmail,
        password: registrationPassword,
        promocod: registrationPromocode.toUpperCase().replace(/\s/g, ""),
        token,
      })
    );
    // debugger;
    if (response?.payload?.message === "User already exists") {
      setFieldError(
        "registrationEmail",
        i18n.language === "en"
          ? response?.payload?.message
          : "Указанный адрес почты уже занят"
      );
      setSubmitting(false);
    } else {
      handleClose();
      if (redirect) {
        navigate(redirect);
        dispatch(setRedirect(""));
      } else {
        setInfoMessage(true);
      }
    }

    setLoading(false);
  };
  const {
    errors,
    touched,
    handleChange,
    handleBlur,
    values,
    setValues,
    handleSubmit,
  } = useFormik({
    onSubmit: HandleSubmit,
    initialValues: {
      registrationEmail: "",
      registrationPassword: "",
      registrationSwitch: false,
      registrationPromocode: "",
      registrationCurrency: "RUB",
      token: "",
    },
    validationSchema: SignupSchema,
  });
  const openRuleModal = () => {
    setRulesModal(true);
  };
  const closeRuleModal = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    setRulesModal(false);
  };

  const isMobile = useMediaQuery({ maxWidth: 600 });

  const onSuccess = (codeResponse: any) => {
    axios
      .get(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`,

        {
          // withCredentials: true,
          headers: {
            Authorization: `Bearer ${codeResponse.access_token}`,
            Accept: "application/json",
          },
        }
      )
      .then(function (response) {
        // handle success
        dispatch(loginWithGoogle({ googleResponse: response.data, promocode }));
      })
      .catch(function (error) {
        // debugger;
        // handle error
        // console.log(error);
      });
  };

  const onError = () => {
    // console.log("Login Failed: ");
  };

  const yandexLogin = () => {
    localStorage.setItem("enprsl", promocode);

    const intervalId = setInterval(() => {
      const gameToken = localStorage.getItem("game-token");

      if (gameToken) {
        dispatch(verifyAuthUser());
        dispatch(setRegistrationModal(false));
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      }
    }, 1000);

    const timeoutId = setTimeout(() => {
      clearInterval(intervalId);
    }, 120000);

    const currentUrl = window.location.origin;
    const redirectUri = `${currentUrl}/login/yandex/callback`;
    //@ts-ignore
    window.YaAuthSuggest.openOauthPopup({
      client_id: process.env.REACT_APP_YANDEX_CLIENT_ID,
      response_type: "token",
      redirect_uri: redirectUri,
    });
  };

  const googleLogin = useGoogleLogin({
    onSuccess,
    onError,
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        sx={{
          height: {
            xs: "calc(var(--real-vh) - 56px - 80px)",
            sm: "calc(var(--real-vh) - 84px)",
          },
          top: { xs: "56px", sm: "84px" },

          overflowY: "auto",
          ".MuiDialog-container": {
            height: "auto",
            alignItems: { xs: "flex-start", sm: "center" },
            padding: {
              xs: "56px 0 80px",
              sm: "84px 0 80px",
            },
            marginTop: "0px",
          },
        }}
        PaperProps={{
          sx: {
            margin: "0",
            width: "100%",
            maxWidth: "400px",
            height: "auto",
            maxHeight: "100%",
            borderRadius: "var(--primary-border-radius)",
            overflowY: "unset",
          },
        }}
      >
        <DialogTitle
          className="dialog-title"
          align="center"
          sx={{
            borderRadius:
              "var(--primary-border-radius) var(--primary-border-radius) 0 0",
            backgroundColor: "var(--secondary-background-color)",
            fontSize: "12px",
            fontWeight: "bold !important",
            lineHeight: "12px",
            textTransform: "uppercase",
            padding: "21px 0",
            position: "relative",
          }}
        >
          {t("registration.title")}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: "14px",
              top: "50%",
              width: "20px",
              height: "20px",
              transform: "translate(0, -50%)",
              backgroundColor: "var(--primary-background-color)",
              padding: "0",
              borderRadius: "4px !important",
            }}
          >
            <CloseIcon sx={{ fontSize: "16px" }} />
          </IconButton>
        </DialogTitle>
        {/* {bonus && (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              backgroundImage: `url(${
                isMobile
                  ? `https://${process.env.REACT_APP_IMAGE_DOMAIN}/bonuses/${bonus.images.mobile.bg_image}`
                  : `https://${process.env.REACT_APP_IMAGE_DOMAIN}/bonuses/${bonus.images.desktop.bg_image}`
              })`,
              backgroundColor: "var(--primary-background-color)",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              objectFit: "cover",
              width: "100%",
              maxHeight: "130px",
              minHeight: "130px",
              position: "relative",
              cursor: "pointer",
            }}
            onClick={openRuleModal}
          >
            <Box
              className="subimg"
              component="img"
              alt="registration"
              src={
                isMobile
                  ? `http://${process.env.REACT_APP_IMAGE_DOMAIN}/bonuses/${bonus.images.mobile.sub_image}`
                  : `http://${process.env.REACT_APP_IMAGE_DOMAIN}/bonuses/${bonus.images.desktop.sub_image}`
              }
            />

            <Typography
              style={{
                width: "calc(100% - 130px)",
                fontSize: "16px",
                fontWeight: 700,
                position: "relative",
                left: "130px",
                zIndex: 1,
              }}
            >
              {bonus.title}
              <br />
              {bonus.description}
            </Typography>
          </Box>
        )} */}
        <DialogContent
          className="dialog-content"
          sx={{
            padding: "24px 40px 36px",
            overflow: "unset",
            borderRadius:
              "0 0 var(--primary-border-radius) var(--primary-border-radius)",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Box style={{ position: "relative" }}>
              <TextField
                error={Boolean(
                  errors.registrationEmail && touched.registrationEmail
                )}
                type="text"
                size="small"
                margin="normal"
                fullWidth
                id="registrationEmail"
                placeholder={t("registration.fields.email")}
                name="registrationEmail"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.registrationEmail}
                sx={{ margin: "0 0 22px 0" }}
                InputProps={
                  errors.registrationEmail && touched.registrationEmail
                    ? {
                        endAdornment: (
                          <InputAdornment position="end">
                            <ErrorOutlineOutlinedIcon
                              style={{
                                color: "rgba(223, 0, 67, 1)",
                                fontWeight: 700,
                              }}
                            />
                          </InputAdornment>
                        ),
                        componentsProps: {
                          input: {
                            style: {
                              padding: "6px 10px",
                              height: "24px",
                              fontSize: "12px",
                              margin: "0px",
                            },
                          },
                        },
                      }
                    : {
                        componentsProps: {
                          input: {
                            style: {
                              padding: "6px 10px",
                              height: "24px",
                              fontSize: "12px",
                            },
                          },
                        },
                      }
                }
              />
              {errors.registrationEmail && touched.registrationEmail ? (
                <Typography
                  className="Typography-error"
                  component="p"
                  variant="body2"
                  sx={{
                    position: "absolute",
                    left: "10px",
                    bottom: "10px",
                  }}
                >
                  {errors.registrationEmail}
                </Typography>
              ) : null}
            </Box>
            <Box style={{ position: "relative" }}>
              <TextField
                error={Boolean(
                  errors.registrationPassword && touched.registrationPassword
                )}
                size="small"
                margin="normal"
                fullWidth
                id="registrationPassword"
                placeholder={t("registration.fields.password")}
                name="registrationPassword"
                autoComplete="off"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.registrationPassword}
                type="password"
                sx={{ margin: "0 0 22px 0" }}
                InputProps={
                  errors.registrationPassword && touched.registrationPassword
                    ? {
                        endAdornment: (
                          <InputAdornment position="end">
                            <ErrorOutlineOutlinedIcon
                              style={{
                                color: "rgba(223, 0, 67, 1)",
                                fontWeight: 700,
                              }}
                            />
                          </InputAdornment>
                        ),
                        componentsProps: {
                          input: {
                            style: {
                              padding: "6px 10px",
                              height: "24px",
                              fontSize: "12px",
                              margin: "0px",
                            },
                          },
                        },
                      }
                    : {
                        componentsProps: {
                          input: {
                            style: {
                              padding: "6px 10px",
                              height: "24px",
                              fontSize: "12px",
                              margin: "0px",
                            },
                          },
                        },
                      }
                }
              />
              {errors.registrationPassword && touched.registrationPassword ? (
                <Typography
                  className="Typography-error"
                  component="p"
                  variant="body2"
                  sx={{
                    position: "absolute",
                    left: "10px",
                    bottom: "10px",
                  }}
                >
                  {errors.registrationPassword}
                </Typography>
              ) : null}
            </Box>
            {openPromocode ? (
              <TextField
                error={Boolean(errors.registrationPromocode)}
                style={{ position: "relative" }}
                size="small"
                margin="normal"
                fullWidth
                id="registrationPromocode"
                placeholder={t("registration.fields.promocode")}
                name="registrationPromocode"
                autoComplete="off"
                onChange={(e) => {
                  handleChange(e);
                  setPromocode(e.currentTarget.value);
                }}
                onBlur={handleBlur}
                value={values.registrationPromocode
                  .toUpperCase()
                  .replace(/\s/g, "")}
                sx={{ margin: "0 0 24px 0" }}
                InputProps={{
                  componentsProps: {
                    input: {
                      style: {
                        padding: "6px 10px",
                        height: "24px",
                        fontSize: "12px",
                        margin: "0px",
                      },
                    },
                  },
                }}
              />
            ) : (
              <Box
                style={{ cursor: "pointer" }}
                onClick={() => setOpenPromocode(true)}
                sx={{
                  fontWeight: "400 !important",
                  color: "var(--primary-text-color)",
                  fontSize: "12px",
                  lineHeight: "18px",
                  margin: "0 0 24px 5px",
                  opacity: "0.75",
                }}
              >
                {t("registration.fields.confirmPromocode")}
              </Box>
            )}
            <ReCaptchaComponent
              callback={(token: any) => {
                console.log(token);
                setValues({ ...values, token });
              }}
              sx={{ marginBottom: "24px" }}
            />

            <Grid
              style={{
                position: "relative",
                display: "flex",
                margin: "10px 0px",
                alignItems: "center",
              }}
            >
              <RedSwitch
                size="small"
                id="registrationSwitch"
                name="registrationSwitch"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.registrationSwitch}
              />

              <Typography component="span" style={{ fontSize: "12px" }}>
                {t("registration.fields.confirmation")}
              </Typography>
              {errors.registrationSwitch && touched.registrationSwitch ? (
                <>
                  <Typography
                    className="Switch-error"
                    component="p"
                    variant="body2"
                  >
                    {errors.registrationSwitch}
                  </Typography>
                  <ErrorOutlineOutlinedIcon />
                </>
              ) : null}
            </Grid>

            <Button
              disabled={loading}
              className={"Button" + ` Button-secondary`}
              type="submit"
              fullWidth
              variant="contained"
              sx={{ margin: "0 0 20px 0", fontWeight: "bold !important" }}
            >
              {loading ? (
                <CircularProgress
                  style={{
                    height: "25px",
                    width: "25px",
                    color: "rgb(223, 0, 67)",
                  }}
                />
              ) : (
                t("registration.title")
              )}
            </Button>

            <Typography component="span" style={{ fontSize: "12px" }}>
              {t("authorization.fast_auth")}
            </Typography>
            <Box className="regmethods">
              <div
                //@ts-ignore
                onClick={googleLogin}
                id="customGoogleBtn"
                className="customGPlusSignIn"
              >
                <img
                  className="icon"
                  //@ts-ignore

                  src={googlePng}
                  alt="Login with Google"
                />
                <span className="buttonText">Google</span>
              </div>
              <div
                //@ts-ignore
                onClick={handleSteamLogin}
                id="customSteamBtn"
                className="customGPlusSignIn"
              >
                <img className="icon" src={steamPng} alt="Login with Steam" />
                <span className="buttonText">Steam</span>
              </div>
              {
                //@ts-ignore
                window && window.YaAuthSuggest ? (
                  <div
                    id="buttonContainerIdyandex"
                    //@ts-ignore
                    onClick={yandexLogin}
                    className="customGPlusSignIn"
                  >
                    <img
                      className="icon"
                      src={yandexPng}
                      alt="Login with Yandex"
                    />
                    <span className="buttonText">Yandex</span>
                  </div>
                ) : null
              }
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontWeight: "400 !important",
                color: "var(--primary-text-color)",
                fontSize: "12px",
                lineHeight: "18px",
                margin: "0 0 24px 5px",
              }}
            >
              <Box sx={{ opacity: "0.75" }}>{t("registration.account")}</Box>
              <Link
                onClick={changeModal}
                variant="body2"
                style={{
                  padding: "0px 0px 0px 5px",
                  color: "rgba(223, 0, 67, 1)",
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                {t("authorization.modal_title")}
              </Link>
            </Box>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog
        open={infoMessage}
        onClose={() => setInfoMessage(false)}
        className="game-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="dialog-title" id="alert-dialog-title">
          {t("registration.modal.title")}
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText id="alert-dialog-description">
            {t("registration.modal.text")}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions">
          <Button
            disabled={loading}
            className={"Button" + ` Button-secondary`}
            onClick={() => {
              setInfoMessage(false);
              // navigate("/profile/payments");
            }}
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {t("buttons.play")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
});

export default Registration;
